import AllProjectsView from "./allProjectsView";
import { ProjectModel } from "../../../base/models/projectModel";
import AddNewProjectView from "./addNewProject";
import UpdateProjectView from "./updateProjectView";

interface Props {
  activeTab: number;
  setActiveTab: (idx: number) => void;
  selectedProject?: ProjectModel;
  setSelectedProject: (value: ProjectModel) => void;
}

const BodyView = ({
  activeTab,
  setActiveTab,selectedProject,
  setSelectedProject
}: Props) => {
  

  return activeTab === 0 ? (
    <AllProjectsView
      setActiveTab={setActiveTab}
      setSelectedProject={setSelectedProject}
    />
  ) : activeTab === 1 ?(
    <>
      <AddNewProjectView />
    </>
  ) : activeTab === 2 ? (<UpdateProjectView project={selectedProject} />) : (<></>) ;
};

export default BodyView;
